import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentArrow = () => {
  return (
    <g>
      <path d="m7.2545 10.671-2.0971-2.0968a.75.75 0 0 0 -1.0606 1.0606l3.3774 3.377a.7527.7527 0 0 0 1.0605 0l3.377-3.377a.75.75 0 0 0 -1.0605-1.0605l-2.0967 2.0966v-4.6582a.75.75 0 0 0 -1.5 0z" />
      <path d="m14.4845.042h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5241a.7433.7433 0 0 0 -.2158.55v10.8719a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.416a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.0208h-2.0205zm8.918 12.3857h-11.4687v-8.8649h3.3008a.75.75 0 0 0 .75-.75v-3.3008h7.418z" />
    </g>
  );
};

export default withIcon(IconDocumentArrow);
